export const RevenueCacheRecalculateComponent = {
    MountAsync: async (target: HTMLElement, props: {}) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { RevenueCacheRecalculateComponent } = await import('./RevenueCacheRecalculateComponent');
        return await mountReactComponentAsync(target, RevenueCacheRecalculateComponent, props);
    }
};
